jQuery(document).ready(function($){
  $('.expert-title_slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $(document).on('click','.ts-video-ply-btn',function(evn){
    evn.preventDefault();
    var heightvideo = $(this).closest('.video__frame').find('.expert-title-image').height();
    console.log(heightvideo)
    $(this).closest('.video__frame').find('.expert-title-image').css('height',heightvideo)
    $(this).next('.youtube_video').find('.js-youtube')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    $(this).closest('.video__frame').addClass('activeVideo_section');
    // var video_html =  $(this).next('.youtube_video').html();
    // $(this).closest('.expert-title-image').html(video_html);
  });

 
  
  $('.slick-3 .multicolumn-list').slick({
    dots: true,
    infinite: false,
    speed: 300,          
    arrows: true,
    slidesToShow:3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.slick-4 .multicolumn-list').slick({
    dots: true,
    infinite: false,
    speed: 300,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,                
          infinite: true,
          centerMode: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,                
          infinite: true,
          centerMode: true
        }
      }
    ]
  });
  $('.slick-continue .multicolumn-list').slick({
    speed: 6000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable:false,
    focusOnSelect:false,
    pauseOnFocus:false,
    pauseOnHover:false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });
  
  $(document).on('click','.moreless-button',function() {
    $(this).closest('.text-with-readmore').toggleClass('more_opened');
    if ($(this).text() == "read more") {
      $(this).text("read less")
    } else {
      $(this).text("read more")
    }
  });

  $(document).on('click','.play',function(){
    var $this = $(this);
    var id = $this.attr('id').replace(/btn/, '');
    $this.closest('li').toggleClass('active');
    if($this.closest('li').hasClass('active')){
      $this.find('.playicon_audio img').attr('src','https://cdn.shopify.com/s/files/1/0748/8710/2770/files/goodpause.png?v=1685085178'); 
      $('audio[class^="sound"]')[id-1].play();        
    } else {
      $this.find('.playicon_audio img').attr('src','https://cdn.shopify.com/s/files/1/0748/8710/2770/files/Goodplay.png');
      $('audio[class^="sound"]')[id-1].pause();
    }
  });

});


//  $('.multi_home_2 .inline-richtext strong').counterUp({
//    duration: 2000,
//    delay: 16,
// });

$( document ).ready( function() {
	
	jQuery(function ($) {
    	"use strict";
    
    	var counterUp = window.counterUp["default"]; // import counterUp from "counterup2"
    
    	var $counters = $(".multi_home_2 .inline-richtext strong");
    
    	/* Start counting, do this on DOM ready or with Waypoints. */
		$counters.each(function (ignore, counter) {
			var waypoint = new Waypoint( {
				element: $(this),
				handler: function() { 
					counterUp(counter, {
						duration: 4000,
						delay: 16
					}); 
					this.destroy();
				},
				offset: 'bottom-in-view',
			} );
		});

	});
 });
